import { render, staticRenderFns } from "./NavbarLink.vue?vue&type=template&id=712056a6&"
import script from "./NavbarLink.vue?vue&type=script&lang=js&"
export * from "./NavbarLink.vue?vue&type=script&lang=js&"
import style0 from "./NavbarLink.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports